import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, NgForm, FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../services/auth/auth.service';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { AuthLegalFooterComponent } from '../../components/auth-legal-footer/auth-legal-footer.component';
import { XdsButtonComponent, XdsIconButtonComponent, XdsBannerComponent, XdsFormFieldComponent, XdsInputComponent } from '../../../../shared/ui';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css'],
    imports: [CommonModule, FormsModule, RouterModule, TranslateModule, AuthLegalFooterComponent, XdsButtonComponent, XdsIconButtonComponent, XdsBannerComponent, XdsFormFieldComponent, XdsInputComponent]
})
export class ForgotPasswordComponent implements OnInit {
  imageUrl: string = '/assets/images/bg-register.jpeg';

  formModel = {
    Email: '',
  };
  errorStatus: any;
  constructor(
    private service: AuthService,
    private fb: UntypedFormBuilder,
    private toasterService: ToastrService,
    public themeService: ThemeService,
    private route: ActivatedRoute
  ) {
    this.errorStatus = this.service.error;
  }

  /**
   * FE-12 P2: `?email=` (vom Sperrtext der Login-Seite) belegt das Feld vor. Nur übernehmen,
   * wenn das Feld noch leer ist — eine Eingabe des Nutzers gewinnt.
   */
  ngOnInit(): void {
    const vorbelegung = (this.route?.snapshot?.queryParamMap?.get('email') ?? '').trim();
    if (vorbelegung && !this.formModel.Email) {
      this.formModel.Email = vorbelegung;
    }
  }

  onSubmit(form: NgForm) {
    this.service.forgotPassword(form.value.Email);
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  getThemeIconClass(): string {
    const mode = this.themeService.getThemeIcon();
    if (mode === 'brightness_auto') return 'fa-circle-half-stroke';
    if (mode === 'light_mode') return 'fa-sun';
    return 'fa-moon';
  }
}
